export default __webpack_public_path__ + "static/media/career_progress.52e44f73.svg";